import { MyFormControl } from "@macashipo/mlib"
export default MyFormControl
